import { DateTime } from 'luxon'

export default (time: number) => {
  return DateTime.fromSeconds(time, {
    zone: 'UTC'
  }).toLocaleString(DateTime.DATE_FULL)
}
